<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header border-0 py-7">
          <div class="card-toolbar d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-sm btn-primary"
              @click="abrirModalNovoBanner"
            >
              <i class="fa fa-plus icon-sm"></i>
              Novo Banner
            </button>
          </div>
        </div>

        <div class="card-body pt-2">
          <div class="table-responsive">
            <table class="table table-head-custom table-vertical-center">
              <thead>
                <tr class="text-left">
                  <th class="min-w-70px">Ordem</th>
                  <th class="min-w-200px">Título</th>
                  <th class="min-w-120px">Prévia</th>
                  <th class="min-w-100px text-center">Qtd. Exibições</th>
                  <th class="min-w-70px text-center">Status</th>
                  <th class="min-w-100px text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="banner in bannersOrdenados"
                  :key="banner.recurso_banner_id"
                >
                  <td>
                    <span class="text-dark-75 fw-bolder d-block fs-6">
                      {{ banner.ordem }}
                    </span>
                  </td>
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="d-flex flex-column">
                        <span
                          class="text-dark-75 fw-bolder text-hover-primary fs-6"
                        >
                          {{ banner.titulo }}
                        </span>
                        <span
                          class="text-muted fw-bold text-muted d-block fs-7"
                        >
                          ID: {{ banner.id }}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td class="text-center align-middle">
                    <div style="width: 150px; height: 50px; overflow: hidden">
                      <img
                        :src="banner.url"
                        :alt="banner.titulo"
                        class="symbol-label"
                        style="width: 100%; height: 100%; object-fit: cover"
                      />
                    </div>
                  </td>
                  <td class="text-center">
                    <span class="text-dark-75 fw-bolder d-block fs-6">
                      {{ banner.qtd_exibicao.toLocaleString("pt-BR") }}
                    </span>
                  </td>
                  <td class="text-center align-middle">
                    <span
                      :class="[
                        'badge',
                        banner.status
                          ? 'label status-on label-inline'
                          : 'label status-off label-inline'
                      ]"
                    >
                      {{ banner.status ? "Ativo" : "Inativo" }}
                    </span>
                  </td>
                  <td class="text-right pr-0">
                    <button
                      class="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
                      @click="editarBanner(banner)"
                      title="Editar"
                    >
                      <i class="fa-solid fa-pencil"></i>
                    </button>
                    <button
                      class="btn btn-icon btn-light btn-hover-danger btn-sm mx-1"
                      @click="excluirBanner(banner)"
                      title="Excluir"
                    >
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="banners.length === 0">
                  <td colspan="6" class="text-center py-10">
                    <div class="text-muted">
                      <i class="fa fa-search-list icon-3x mb-3"></i>
                      <div class="fw-bold fs-4">Nenhum banner encontrado</div>
                      <div class="fs-6">
                        Clique em "Novo Banner" para adicioná-los
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Edição/Novo Banner -->
    <div class="modal fade" id="modalBanner" tabindex="-1" ref="modalBanner">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ bannerEdicao.id ? "Editar Banner" : "Novo Banner" }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="salvarBanner">
              <div class="row">
                <div class="col-md-8">
                  <div class="mb-4">
                    <label class="form-label required">Título</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="bannerEdicao.titulo"
                      placeholder="Digite o título do banner"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-4">
                    <label class="form-label required">Ordem</label>
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="bannerEdicao.ordem"
                      placeholder="1"
                      min="1"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="mb-4">
                <label class="form-label required">URL da Imagem</label>
                <input
                  type="url"
                  class="form-control"
                  v-model="bannerEdicao.url"
                  placeholder="https://exemplo.com/imagem.png"
                  required
                />
              </div>

              <div class="mb-4" v-if="bannerEdicao.url">
                <label class="form-label">Preview</label>
                <div class="p-3 bg-light rounded">
                  <img
                    :src="bannerEdicao.url"
                    :alt="bannerEdicao.titulo"
                    style="
                      max-width: 100%;
                      max-height: 200px;
                      object-fit: contain;
                    "
                    @error="imagemError = true"
                    @load="imagemError = false"
                  />
                  <div v-if="imagemError" class="text-danger mt-2">
                    <i class="fa fa-close-circle"></i> Erro ao carregar imagem
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-4">
                    <label class="form-label">Status</label>
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="bannerEdicao.status"
                        id="statusBanner"
                      />
                      <label class="form-check-label" for="statusBanner">
                        {{ bannerEdicao.status ? "Ativo" : "Inativo" }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="fecharModal"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="salvarBanner"
              :disabled="salvandoBanner"
            >
              <span
                v-if="salvandoBanner"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              {{ bannerEdicao.id ? "Atualizar" : "Criar" }}
              Banner
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import API_LINKS from "./automacao/api.links.js";
import "moment/locale/pt-br";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { Modal } from "bootstrap";

export default {
  data() {
    return {
      banners: [],
      bannerEdicao: {
        id: null,
        titulo: "",
        url: "",
        regra: false,
        status: true,
        qtd_exibicao: 0,
        painel: true,
        ordem: 1
      },
      modalBannerInstance: null,
      salvandoBanner: false,
      imagemError: false
    };
  },

  computed: {
    bannersOrdenados() {
      if (!this.banners || !Array.isArray(this.banners)) return [];
      return [...this.banners].sort((a, b) => a.ordem - b.ordem);
    }
  },

  methods: {
    novoBannerVazio() {
      return {
        id: null,
        titulo: "",
        url: "",
        regra: false,
        status: "[-1]",
        qtd_exibicao: 0,
        painel: true,
        ordem: this.proximaOrdem()
      };
    },

    proximaOrdem() {
      if (
        !this.banners ||
        !Array.isArray(this.banners) ||
        this.banners.length === 0
      ) {
        return 1;
      }
      const maiorOrdem = Math.max(
        ...this.banners.map((banner) => banner.ordem || 0)
      );
      return maiorOrdem + 1;
    },

    async listarBanners() {
      try {
        const res = await ApiService.get(API_LINKS.banners);
        this.banners = res.data.recursos || res.data || [];
      } catch (error) {
        console.error("Erro ao carregar banners:", error);
        Swal.fire({
          icon: "error",
          title: "Erro!",
          text: "Erro ao carregar lista de banners!"
        });
      }
    },

    abrirModalNovoBanner() {
      this.bannerEdicao = this.novoBannerVazio();
      this.imagemError = false;
      this.modalBannerInstance.show();
    },

    editarBanner(banner) {
      this.bannerEdicao = { ...banner };
      this.imagemError = false;
      this.modalBannerInstance.show();
    },

    async salvarBanner() {
      if (!this.bannerEdicao.titulo || !this.bannerEdicao.url) {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "Título e URL são obrigatórios!"
        });
        return;
      }

      this.salvandoBanner = true;

      try {
        const dados = {
          titulo: this.bannerEdicao.titulo,
          url: this.bannerEdicao.url,
          ordem: this.bannerEdicao.ordem,
          painel: true,
          recurso: this.bannerEdicao.status ? "[-1]" : "[]",
          regra: this.bannerEdicao.regra || false
        };

        if (this.bannerEdicao.id) {
          // Editar banner existente
          await ApiService.put(
            `${API_LINKS.banners}/${this.bannerEdicao.id}`,
            dados
          );
        } else {
          // Criar novo banner
          await ApiService.post(API_LINKS.banners, dados);
        }

        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: `Banner ${
            this.bannerEdicao.id ? "atualizado" : "criado"
          } com sucesso!`
        });

        this.modalBannerInstance.hide();
        await this.listarBanners();
      } catch (error) {
        console.error("Erro ao salvar banner:", error);
        Swal.fire({
          icon: "error",
          title: "Erro!",
          text: `Erro ao ${
            this.bannerEdicao.id ? "atualizar" : "criar"
          } banner!`
        });
      } finally {
        this.salvandoBanner = false;
      }
    },

    async excluirBanner(banner) {
      const resultado = await Swal.fire({
        title: "Tem certeza?",
        text: `Deseja excluir o banner "${banner.titulo}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar"
      });

      if (resultado.isConfirmed) {
        try {
          await ApiService.delete(`${API_LINKS.banners}/${banner.id}`);

          Swal.fire({
            icon: "success",
            title: "Excluído!",
            text: "Banner excluído com sucesso!"
          });

          await this.listarBanners();
        } catch (error) {
          console.error("Erro ao excluir banner:", error);
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: "Erro ao excluir banner!"
          });
        }
      }
    },

    fecharModal() {
      this.bannerEdicao = this.novoBannerVazio();
      this.imagemError = false;
      this.modalBannerInstance.hide();
    }
  },

  mounted() {
    this.listarBanners();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Banners"
      }
    ]);

    // Inicializar modal do Bootstrap
    this.modalBannerInstance = new Modal(this.$refs.modalBanner);
  },

  beforeUnmount() {
    if (this.modalBannerInstance) {
      this.modalBannerInstance.dispose();
    }
  }
};
</script>

<style scoped>
.symbol-label {
  border-radius: 0.475rem;
}

.table th {
  border-top: 0;
  font-weight: 600;
  color: #7e8299;
}

.form-label.required::after {
  content: " *";
  color: #f64e60;
}

.modal-dialog {
  max-width: 600px;
}

.status-on {
  background-color: rgba(97, 191, 3, 0.308);
  width: 40px;
  height: 15px;
  color: green;
}
.status-off {
  background-color: rgb(214, 21, 21, 0.308);
  width: 50px;
  height: 15px;
  color: red;
}
</style>
